<template>
  <section class="why-choose">
    <h2 class="why-choose-title">Why Choose Banana's ARM?</h2>
    <div class="features">
      <div class="feature" v-for="(feature, index) in features" :key="index">
        <img :src="feature.icon" :alt="feature.title" class="feature-icon" />
        <h3 class="feature-title">{{ feature.title }}</h3>
        <p class="feature-description">{{ feature.description }}</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "WhyChoose",
  data() {
    return {
      features: [
        {
          title: "Precision Engineering",
          description: "Crafted with the highest precision for flawless performance.",
          icon: "@/assets/precision-icon.png",
        },
        {
          title: "Military-Grade Materials",
          description: "Built to last with durable, top-quality materials.",
          icon: "@/assets/military-icon.png",
        },
        {
          title: "Trusted by Professionals",
          description: "The choice of experts around the globe.",
          icon: "@/assets/trusted-icon.png",
        },
      ],
    };
  },
};
</script>

<style scoped>
.why-choose {
  background-color: #f7f7f7;
  padding: 40px 20px;
  text-align: center;
  border-radius: 8px;
  max-width: 800px;
  margin: 0 auto;
}

.why-choose-title {
  font-size: 1.8em;
  margin-bottom: 20px;
  color: #333;
}

.features {
  display: flex;
  justify-content: space-around;
  gap: 20px;
  flex-wrap: wrap;
}

.feature {
  text-align: center;
  max-width: 200px;
}

.feature-icon {
  width: 50px;
  height: 50px;
  margin-bottom: 10px;
}

.feature-title {
  font-size: 1.2em;
  font-weight: bold;
  margin: 10px 0;
  color: #333;
}

.feature-description {
  font-size: 0.9em;
  color: #666;
}
</style>
